module.exports = __webpack_public_path__ + "static/img/FuZhuang_jianjiePic.515e0efe.png";